import React from 'react';
import { School as SchoolIcon } from 'lucide-react';
import { School } from '../../../types/admin';

interface SchoolListProps {
  schools: School[];
  selectedSchool: School | null;
  onSelectSchool: (school: School) => void;
}

export default function SchoolList({ schools, selectedSchool, onSelectSchool }: SchoolListProps) {
  return (
    <div className="space-y-2">
      <h3 className="text-sm font-medium text-text-secondary mb-2">Your Schools</h3>
      {schools.map((school) => (
        <button
          key={school.id}
          onClick={() => onSelectSchool(school)}
          className={`w-full p-4 rounded-lg transition-colors flex items-center gap-3
                   ${selectedSchool?.id === school.id 
                     ? 'bg-primary-50 border-2 border-primary-500' 
                     : 'hover:bg-primary-50'}`}
        >
          <div className="p-2 bg-primary-100 rounded-lg">
            <SchoolIcon className="w-5 h-5 text-primary-600" />
          </div>
          <div className="flex-1 text-left">
            <h4 className="font-medium text-text-primary">{school.name}</h4>
            <p className="text-sm text-text-secondary">Code: {school.code}</p>
            {school.city && school.state && (
              <p className="text-xs text-text-muted mt-1">
                {school.city}, {school.state}
              </p>
            )}
          </div>
        </button>
      ))}

      {schools.length === 0 && (
        <p className="text-center text-text-secondary py-4">
          No schools found. Join a school or create a new one.
        </p>
      )}
    </div>
  );
}